import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { message } from 'antd';

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}

// 与后端约定的响应数据格式
interface ResponseStructure {
  success?: boolean;
  data?: any;
  // 后端错误响应格式
  code?: number;
  message?: string;
  requestId?: string;
  timestamp?: number;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const { success, data, code, message: msg,  } =
        res as unknown as ResponseStructure;
      
      // 后端返回 success: false 或者返回了 code（非 10000 表示错误）
      if (success === false || (code !== undefined && code !== 10000)) {
        const error: any = new Error(msg  || '请求失败');
        error.name = 'BizError';
        error.info = { 
          errorCode: code , 
          errorMessage: msg ,
          data 
        };
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      
      // 我们的 errorThrower 抛出的错误。
      if (error.name === 'BizError') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { message: errorMessage } = errorInfo;
          message.error(errorMessage);
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        const { status } = error.response;
        
        // 401 未授权，跳转到登录页
        if (status === 401) {
          message.error('登录已过期，请重新登录');
          // 清除可能存在的认证信息
          localStorage.removeItem('token');
          sessionStorage.clear();
          // 跳转到登录页
          history.push('/login');
          return;
        }
        
        const responseData = error.response.data as ResponseStructure;
        const errorMsg = responseData?.message || `请求错误: ${status}`;
        message.error(errorMsg);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        message.error('网络错误，请检查网络连接');
      } else {
        // 发送请求时出了点问题
        message.error('请求错误，请重试');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 携带 Cookie 进行跨域请求
      config.credentials = 'include';
      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      // 注意：不要在这里弹出错误消息，让 errorHandler 统一处理
      return response;
    },
  ],
};
